import { Logger } from '@farmersdog/logger';

import type { BranchNode } from '../../blueprint/types';
import type { FetchLeadQuery } from '../../graphql/types';
import type { UseFormNavigateReturn } from '../../types';

interface TrackInvalidFormStepIndexArgs {
  current: string | undefined;
  formSteps: BranchNode[];
  formNavigation: UseFormNavigateReturn;
  lead: FetchLeadQuery['lead'] | null;
}

const logger = new Logger('tosa:frontend:invalidFormNavigationIndex');

export function trackInvalidFormStepIndex({
  current,
  formSteps,
  formNavigation,
  lead,
}: TrackInvalidFormStepIndexArgs) {
  if (current && formSteps.length > 0) {
    const currentIndex = formNavigation.findCurrentIndex({ formSteps });
    if (currentIndex === -1) {
      logger.error('Could not find valid current index for form navigation', {
        anonymousId: lead?.anonymousId,
        corePostgresUserId: lead?.corePostgresUserId,
        email: lead?.email,
      });
    }
  }
}
